export { LogoAxis } from './axis';
export type { LogoAxisProps } from './axis';
